import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './AccountDetails.css';
import { API, authHeadersOnly } from '../services/apiConfig';

function AccountDetails({ userId, onClose }) {
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [submitMsg, setSubmitMsg] = useState({ text: '', type: '' });
  const [formData, setFormData] = useState({ name: '', email: '', phone: '' });
  const errStyle = { color: '#c0392b', fontSize: '12px', marginTop: '4px' };

  const validate = () => {
    const e = {};
    if (!formData.name.trim()) e.name = 'Name is required';
    if (!formData.email.includes('@')) e.email = 'Email must contain @';
    if (!/^[0-9]{10}$/.test(formData.phone)) e.phone = 'Phone must be exactly 10 digits';
    return e;
  };

  useEffect(() => {
    fetchUserDetails();
  }, []);

  const fetchUserDetails = async () => {
    try {
      const response = await axios.get(`${API}/api/auth/user/${userId}/profile`, { headers: authHeadersOnly() });
      setFormData({
        name: response.data.name || '',
        email: response.data.email || '',
        phone: response.data.phone || ''
      });
    } catch (error) {
      console.error('Error fetching user details:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) { setErrors(validationErrors); return; }
    setErrors({});
    try {
      await axios.put(`${API}/api/auth/user/${userId}/profile`, formData, { headers: authHeadersOnly() });
      setSubmitMsg({ text: 'Profile updated successfully!', type: 'success' });
      setTimeout(() => setSubmitMsg({ text: '', type: '' }), 3000);
    } catch (error) {
      setSubmitMsg({ text: error.response?.data?.message || 'Failed to update profile. Please try again.', type: 'error' });
    }
  };

  return (
    <div className="account-details-overlay" onClick={onClose}>
      <div className="account-details-modal" onClick={(e) => e.stopPropagation()}>
        <div className="details-header">
          <h2>Account Details</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="details-content">
          {loading ? (
            <div className="loading">Loading...</div>
          ) : (
            <form className="details-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Full Name</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => { setFormData({...formData, name: e.target.value}); setErrors(p=>({...p,name:''})); }}
                  required
                />
                {errors.name && <p style={errStyle}>{errors.name}</p>}
              </div>

              <div className="form-group">
                <label>Email Address</label>
                <input
                  type="text"
                  value={formData.email}
                  onChange={(e) => { setFormData({...formData, email: e.target.value}); setErrors(p=>({...p,email:''})); }}
                  required
                />
                {errors.email && <p style={errStyle}>{errors.email}</p>}
              </div>

              <div className="form-group">
                <label>Phone Number</label>
                <input
                  type="tel"
                  value={formData.phone}
                  onKeyDown={(e) => {
                    if (!/[0-9]/.test(e.key) && !['Backspace','Delete','ArrowLeft','ArrowRight','Tab'].includes(e.key)) e.preventDefault();
                  }}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, '').slice(0, 10);
                    setFormData({...formData, phone: val});
                    setErrors(p=>({...p,phone:''}));
                  }}
                  maxLength="10"
                  required
                />
                {errors.phone && <p style={errStyle}>{errors.phone}</p>}
              </div>

              {submitMsg.text && (
                <p style={{ color: submitMsg.type === 'success' ? '#16a34a' : '#c0392b', fontSize: '13px', marginBottom: '8px', fontWeight: '600' }}>
                  {submitMsg.text}
                </p>
              )}
              <button type="submit" className="btn-save">Save Changes</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default AccountDetails;
